import React, { useEffect } from "react";
import { Download, ExternalLink, FileSpreadsheet, FileText, Presentation } from "lucide-react";

import "./DocumentContentViewer.css";

const getTypeLabel = (contentType) => {
    switch (contentType) {
        case "WORD":
            return "Document Word";
        case "EXCEL":
            return "Classeur Excel";
        case "PPT":
            return "Presentation PowerPoint";
        default:
            return "Document";
    }
};

const getTypeIcon = (contentType) => {
    switch (contentType) {
        case "EXCEL":
            return <FileSpreadsheet size={18} />;
        case "PPT":
            return <Presentation size={18} />;
        default:
            return <FileText size={18} />;
    }
};

export default function DocumentContentViewer({ content, fileUrl, progress, onTrack }) {
    useEffect(() => {
        const timerId = window.setInterval(() => {
            if (!document.hidden) {
                onTrack?.({
                    timeSpentDeltaSeconds: 1,
                    completionPercent: Math.max(Number(progress?.progressPercent || 0), 5),
                    progressPayload: {
                        documentType: content.contentType,
                    },
                });
            }
        }, 1000);

        return () => window.clearInterval(timerId);
    }, [content?.id, content.contentType, onTrack]);

    return (
        <div className="dcv-card">
            <div className="dcv-head">
                {getTypeIcon(content.contentType)}
                <div>
                    <strong>{getTypeLabel(content.contentType)}</strong>
                    <p>
                        L'aperçu inline n'est pas encore fiable pour ce format dans LOT 3. Le suivi conserve l'ouverture et le
                        temps passe, avec completion manuelle en fallback.
                    </p>
                </div>
            </div>

            <div className="dcv-actions">
                <a className="cr-btn cr-btn--secondary" href={fileUrl} target="_blank" rel="noopener noreferrer">
                    Ouvrir le fichier
                    <ExternalLink size={16} />
                </a>
                <a className="cr-btn cr-btn--secondary" href={fileUrl} download={content.fileName || true}>
                    Telecharger
                    <Download size={16} />
                </a>
            </div>
        </div>
    );
}